import { render, staticRenderFns } from "./evaluationList.vue?vue&type=template&id=fa3a6b4e&scoped=true"
import script from "./evaluationList.vue?vue&type=script&lang=js"
export * from "./evaluationList.vue?vue&type=script&lang=js"
import style0 from "./evaluationList.vue?vue&type=style&index=0&id=fa3a6b4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3a6b4e",
  null
  
)

export default component.exports